import { render, staticRenderFns } from "./Battles.vue?vue&type=template&id=030d67c4&scoped=true"
import script from "./Battles.vue?vue&type=script&lang=js"
export * from "./Battles.vue?vue&type=script&lang=js"
import style0 from "./Battles.vue?vue&type=style&index=0&id=030d67c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d67c4",
  null
  
)

export default component.exports